export default "__VITE_ASSET__d375854f__"